import { combineReducers } from 'redux';
import systemInfo from './sysInfoReducer';
import user from './userReducer';
import logs from './logReducer';
import language from './languageReducer';
import imageEditors from '../features/imageeditors/ImageEditorsReducer';
import productsResult from '../features/products/reducers/ProductReducer';
import se360Users from '../features/se360users/Reducer';
import content from './contentReducer';
import download from './downloadReducer';
import productTypes from '../features/producttypes/Reducer';
import regions from '../features/regions/reducers/RegionReducer';
import photographers from '../features/photographers/PhotographerReducer';
import agreements from '../features/agreements/AgreementsReducer';
import planFirms from '../features/planfirms/Reducer';
import styling from '../features/stylingfirms/reducer/StylingFirmsReducer';
import stylinguser from '../features/stylingusers/reducer/StylingUserReducer';
import productGroups from '../features/productGroups/Reducer';
import brokers from '../features/brokers/reducers/BrokerReducer';
import logs2 from '../features/logs/Reducer';
import planEditors from '../features/planeditors/Reducer';
import legalEntities from '../features/legalentities/Reducer';
import specialAuthorizations from '../features/se360users/specialauthorizations/Reducer';
import orders from '../features/orders/OrdersReducer';
import invoices from '../features/invoice/InvoiceReducer';
import singlePhotographerInvoice from '../features/invoice/photographer/photographer/SinglePhotographerInvoiceReducer';
import photographerUploads from '../features/photographerupload/reducer/PhotographerUploadReducer';
import planTemplates from '../features/plantemplates/Reducer';
import site from './siteReducer';
import templates from '../features/templates/reducers/TemplateReducer';
import imageProcessing from '../features/orders/view/imageprocessing/reducer/ImageProcessingReducer';
import calendar from '../features/photographerPersonalCalendar/reducers/CalendarReducer';
import photographerCalendars from '../features/photographerCalendars/reducers/PhotographerCalendarsReducer';
import commonTexts from '../features/commontexts/Reducer';
import SE360PhotographerBooking from '../features/photographerBooking/se360/reducers/SE360PhotographerBookingReducer';
import ScandphotosPhotographerBooking from '../features/photographerBooking/scandphotos/reducers/ScandphotosPhotographerBookingReducer';
import viewOrder from '../features/orders/view/Reducer';
import basicOrderInfo from '../features/orders/view/basicorderinfo/Reducer';
import profile from '../features/profile/Reducer';
import viewOrderContact from '../features/orders/view/contactaddress/OrderContactReducer';
import orderText from '../features/orders/view/texthandling/OrderTextReducer';
import photographerAgreement from '../features/photographerAgreement/Reducer';
import viewPlanOrder from '../features/orders/view/planOrders/reducers/PlanOrderReducer';
import imageEditorFirms from '../features/imageeditorfirms/reducer/ImageEditorFirmsReducer';
import { photoOrderListReducer } from '../features/photoorderlists/reducers/PhotoOrderListReducer';
import { futurePhotoOrderListReducer } from '../features/photoorderlists/reducers/PhotoOrderListReducer';
import ordersList from '../features/planeditorOrders/reducer/PlanEditorOrdersReducer';
import scandphotosCreateOrder from '../features/orders/scandphotos/reducers/ScandphotosCreateOrderReducer';
import orderCollection from '../features/orders/view/ordercollection/OrderCollectionReducer';
import photographerOverview from '../features/photographerOverview/reducers/PhotographerOverviewReducer';
import deliveredImagesGallery from '../features/deliveredimagegallery/Reducer';
import planAnnotation from '../features/planannotation/reducers/PlanAnnotationReducer';
import statistics from '../features/statistics/reducer/StatisticsReducer';
import genericOrder from '../features/orders/view/generic/GenericOrderReducer';
import invoiceJournal from '../features/invoiceJournals/reducers/InvoiceJournalReducer';
import paymentJournal from '../features/paymentJournals/reducers/PaymentJournalReducer';
import invoiceProductType from '../features/invoiceProductType/Reducer';
import receivable from '../features/receivable/ReceivableReducer';
import multiplePhotographersInvoice from '../features/invoice/photographer/photographers/MultiplePhotographersInvoiceReducer';
import router from './RouterReducer';
import stylingUserCalendar from '../features/stylingUserPersonalCalendars/reducers/CalendarReducer';
import showcaseOrder from '../features/orders/view/showcaseHandling/reducers/ShowcaseOrderReducer';

const rootReducer = combineReducers({
    systemInfo,
    site,
    user,
    logs,
    language,
    imageEditors,
    productsResult,
    download,
    se360Users,
    content,
    productTypes,
    regions,
    planFirms,
    productGroups,
    photographers,
    agreements,
    brokers,
    logs2,
    planEditors,
    legalEntities,
    orders,
    specialAuthorizations,
    photographerUploads,
    planTemplates,
    templates,
    imageProcessing,
    calendar,
    SE360PhotographerBooking,
    ScandphotosPhotographerBooking,
    commonTexts,
    viewOrder,
    basicOrderInfo,
    profile,
    viewOrderContact,
    photographerCalendars,
    photographerOverview,
    photographerAgreement,
    viewPlanOrder,
    invoices,
    imageEditorFirms,
    photoOrderLists: photoOrderListReducer,
    ordersList,
    scandphotosCreateOrder,
    orderCollection,
    singlePhotographerInvoice,
    deliveredImagesGallery,
    planAnnotation,
    statistics,
    orderText,
    genericOrder,
    futureOrders: futurePhotoOrderListReducer,
    invoiceJournal,
    paymentJournal,
    invoiceProductType,
    receivable,
    multiplePhotographersInvoice,
    styling,
    stylinguser,
    router,
    stylingUserCalendar,
    showcaseOrder
});

export default rootReducer;
